import React from 'react';
import { Button } from './ui/Button';
import { SparklesIcon } from 'lucide-react';
export function CallToAction() {
  return <section className="py-24 bg-gradient-to-br from-red-900 via-red-800 to-red-900 relative overflow-hidden" data-id="element-24">
      {/* Texture overlay */}
      <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-25"></div>

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-26">
        <div className="inline-block p-3 rounded-full bg-white/10 backdrop-blur-sm mb-8 animate-bounce" data-id="element-27">
          <SparklesIcon className="w-8 h-8 text-amber-400" data-id="element-28" />
        </div>

        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-29">
          Transform Your Drama Classes with the <br data-id="element-30" />
          <span className="text-amber-400" data-id="element-31">Ultimate Teacher's Toolkit</span>
        </h2>

        <p className="text-xl text-red-100 max-w-2xl mx-auto mb-10" data-id="element-32">
          Get instant access to hundreds of lesson plans, activities, and
          production resources. Start enjoying your evenings again.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-33">
          <a href="https://checkout.digitalpack.shop/cart/43448261443662:1" target="_blank" rel="noopener noreferrer" data-id="element-34">
            <Button size="lg" variant="secondary" className="text-xl px-10 py-6 shadow-2xl shadow-amber-900/50 hover:scale-105 transform transition-all" data-id="element-35">
              Get the Toolkit Now!
            </Button>
          </a>
        </div>

        <p className="mt-6 text-sm text-red-200 opacity-80" data-id="element-36">
          Instant Access • Secure Payment • 7-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}